module.exports = __webpack_public_path__ + "img/news_02.4cd51dde.jpg";